import React from "react";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";

const CookiePolicy = () => {
  const { t } = useLang();

  const why = t("privacy.why") || [];
  const sections = t("privacy.sections") || [];
  const rights = t("privacy.rights") || [];

  return (
    <div data-testid="privacy-policy-page">
      <PageHero
        variant="light"
        kicker="arts4all"
        title={t("privacy.pageTitle")}
        lead={t("privacy.pageLead")}
      />

      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-3xl px-5 lg:px-8 space-y-10">
          {/* Perché questo avviso */}
          <Reveal>
            <h2 className="font-serif text-2xl md:text-3xl text-[#1c1b1a]">
              {t("privacy.whyTitle")}
            </h2>
            {why.map((p, i) => (
              <p key={i} className="mt-3 text-[#4a463f] leading-relaxed">
                {p}
              </p>
            ))}
          </Reveal>

          {/* Sezioni numerate */}
          {sections.map((s, i) => (
            <Reveal key={i} delay={Math.min(i, 4) * 50}>
              <h2 className="font-serif text-2xl md:text-3xl text-[#1c1b1a]">{s.title}</h2>
              {(s.body || []).map((p, j) => (
                <p key={j} className="mt-3 text-[#4a463f] leading-relaxed">
                  {p}
                </p>
              ))}
            </Reveal>
          ))}

          {/* Diritti */}
          <Reveal data-testid="gdpr-rights-section">
            <h2 className="font-serif text-2xl md:text-3xl text-[#1c1b1a]">
              {t("privacy.rightsTitle")}
            </h2>
            <p className="mt-3 text-[#4a463f] leading-relaxed">{t("privacy.rightsIntro")}</p>
            <ul className="mt-5 space-y-3">
              {rights.map((r, i) => {
                const [label, ...rest] = r.split(":");
                const desc = rest.join(":").trim();
                return (
                  <li key={i} className="flex gap-3 text-[#4a463f] leading-relaxed">
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#b5533a]" />
                    <span>
                      <strong className="text-[#1c1b1a]">{label}</strong>
                      {desc ? ` — ${desc}` : ""}
                    </span>
                  </li>
                );
              })}
            </ul>
            <p className="mt-5 text-[#4a463f] leading-relaxed">{t("privacy.rightsHow")}</p>
          </Reveal>

          {/* Aggiornamenti */}
          <Reveal>
            <h2 className="font-serif text-2xl md:text-3xl text-[#1c1b1a]">
              {t("privacy.updatesTitle")}
            </h2>
            <p className="mt-3 text-[#4a463f] leading-relaxed">{t("privacy.updatesText")}</p>
            <p className="mt-4 text-sm uppercase tracking-[0.14em] text-[#8a8478]">
              {t("privacy.updated")}
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
